import { queryClient, apiRequest } from "../lib/queryClient";

const profileKey = "profile";

export function useProfile(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;
    const fetchProfile = async () => {
    
    const response = await apiRequest(
      `/auth/profile`,
      {
        method: "GET",
      }
    );
    return response;
  };

 

  const updateProfile= async (pageData) => {
    const response = await apiRequest(`/auth/profile`, {
      method: "PUT",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [profileKey] });
    return response;
  };



 



  return {
    fetchProfile,
    updateProfile,
  };
}
